import React, { useEffect } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'

interface RedirectPreserverProps extends RouteComponentProps {
  children: React.ReactNode
}

const RedirectPreserver: React.FC<RedirectPreserverProps> = ({ location, history, children }) => {
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    if (!searchParams.has('redirect')) {
      const fullPath = location.pathname + location.search
      const newParams = new URLSearchParams()
      newParams.set('redirect', fullPath)
      history.replace({
        pathname: '/',
        search: newParams.toString()
      })
    }
  }, [location.pathname, location.search, history])

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>
}

export default withRouter(RedirectPreserver)
